import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { resolveEmployeeStoreContext } from './entityContext';
import {
  DEFAULT_DELIVERY_AGENT_ORDER_SOURCE,
  getDeliveryAgentOrderSources,
} from './menuChannels';
import './css/Home.css';
import './css/Employee.css';

/** Delivery-agent employee shell — Orders tab + MYEATS / Restaurant (or JREATS) subnav only. */
const EmployeeDashboardLayout = ({
  children,
  deliveryOrderSource = DEFAULT_DELIVERY_AGENT_ORDER_SOURCE,
  deliveryOrderSources: deliveryOrderSourcesProp,
  onNavigateOrders,
  onSelectOrderSource,
  showOrderSourceSubnav = true,
}) => {
  const navigate = useNavigate();
  const user = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('user') || 'null');
    } catch {
      return null;
    }
  }, []);
  const isStore = resolveEmployeeStoreContext(user);
  const deliveryOrderSources = useMemo(() => {
    if (Array.isArray(deliveryOrderSourcesProp) && deliveryOrderSourcesProp.length > 0) {
      return deliveryOrderSourcesProp;
    }
    return getDeliveryAgentOrderSources(isStore);
  }, [deliveryOrderSourcesProp, isStore]);

  const goToOrders = (source = deliveryOrderSource) => {
    if (onNavigateOrders) {
      onNavigateOrders(source);
      return;
    }
    navigate('/business/user', { state: { deliveryOrderSource: source } });
  };

  const handleSourceClick = (key) => {
    if (onSelectOrderSource) {
      onSelectOrderSource(key);
      return;
    }
    goToOrders(key);
  };

  return (
    <div className="restaurant-dashboard restaurant-dashboard--flush employee-dashboard">
      <aside className="restaurant-dashboard-sidebar" aria-label="Employee navigation">
        <button
          type="button"
          className="restaurant-dashboard-sidebar-item active"
          onClick={() => goToOrders()}
        >
          Orders
        </button>
        {showOrderSourceSubnav ? (
          <div
            className="restaurant-dashboard-subnav"
            role="group"
            aria-label="Order source"
          >
            {deliveryOrderSources.map((channel) => {
              const Icon = channel.icon;
              return (
                <button
                  key={channel.key}
                  type="button"
                  className={`restaurant-dashboard-subnav-item${
                    deliveryOrderSource === channel.key ? ' active' : ''
                  }`}
                  onClick={() => handleSourceClick(channel.key)}
                >
                  <Icon
                    className="restaurant-dashboard-subnav-icon"
                    aria-hidden="true"
                  />
                  <span>{channel.label}</span>
                </button>
              );
            })}
          </div>
        ) : null}
      </aside>
      <main className="restaurant-dashboard-main restaurant-dashboard-main--flush employee-dashboard-main">
        {children}
      </main>
    </div>
  );
};

export default EmployeeDashboardLayout;
